import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { surpriseService } from '@/services/surprise';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useSurpriseSetting() {
    const crudAction = useCrudActions();

    const model = reactive({
        autoSendPercent: 0,
        autoSendSurpriseItems: '',
        surpriseCategoryForBet: '',
        botAutoSendPercent: 0,
        botAutoReceivePercent: 0,
        canRemove: false
    });

    const validations = {
        autoSendPercent: { required, integer, minValue: minValue(0) },
        autoSendSurpriseItems: {
            format: validateFormat(/^\d+(,\d+)*$/, 'Please enter in the correct format: Ex: 2,3,5 [in integer numbers]')
        },
        surpriseCategoryForBet: {
            format: validateFormat(/^(\d+(,\d+)*)(;\d+(,\d+)*)*$/, 'Please enter in the correct format: Ex: 7,7;9,9')
        },
        botAutoSendPercent: { required, integer, minValue: minValue(0) },
        botAutoReceivePercent: { required, integer, minValue: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: surpriseService.setting.get,
        onSuccess: ({ data }) => {
            model.autoSendPercent = data.autoSendPercent;
            model.surpriseCategoryForBet = data.surpriseCategoryForBet;
            model.botAutoSendPercent = data.botAutoSendPercent;
            model.botAutoSendPercent = data.botAutoSendPercent;
            model.autoSendSurpriseItems = data.autoSendSurpriseItems;
            model.botAutoReceivePercent = data.botAutoReceivePercent;
            model.canRemove = data.canRemove;
        },
        onError: () => {
            model.autoSendPercent = 0;
            model.autoSendSurpriseItems = '';
            model.surpriseCategoryForBet = '';
            model.botAutoSendPercent = 0;
            model.botAutoReceivePercent = 0;
            model.canRemove = false;
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                surpriseService.setting.update(
                    model.autoSendPercent,
                    model.autoSendSurpriseItems,
                    model.surpriseCategoryForBet,
                    model.botAutoSendPercent,
                    model.botAutoReceivePercent
                ),
            onSuccess: fetch
        }),

        remove: crudAction.confirmAndRemove({
            request: surpriseService.setting.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, actions, fetch };
}
